import { render, staticRenderFns } from "./StockReportPage.vue?vue&type=template&id=bfbe189e&scoped=true&"
import script from "./StockReportPage.vue?vue&type=script&lang=js&"
export * from "./StockReportPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfbe189e",
  null
  
)

export default component.exports